import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as cacheRedisAction from './../../../../actions/cacheRedisAction';
import ClearCache from './ClearCache';

const mapStateToProps = state => {
  return {
    cacheRedisState: state.cacheRedisReducer,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    getListCache: () => dispatch(cacheRedisAction.getListRedisCache()),
    deleteCache: (params) => dispatch(cacheRedisAction.deleteRedisKeyAction(params)),
  }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ClearCache));
